import { secondsToHms } from './../../core/Time/_time.js';
import { replaceString, trimAll } from './../../core/String/_string.js';

function countSentences(freshText) {
  let text = freshText;

  text = replaceString.everySentenceEndIsPeriod(text);

  // don't count numbers as sentence end
  text = replaceString.removeDecimalNumbersEnglish(text);
  text = replaceString.removeNumberAdjCzech(text);

  // don't count 123 or other characters as letters
  text = replaceString.onlyLettersCzech(text);

  // ABBR czech - todo - je jich více
  text = replaceString.abbrCzech(text);

  // todo: řešit s &nbsp; - lepší
  text = replaceString.monthsCzech(text);

  const sentenceArray = text.split(".");
  const lastChar =  freshText.slice(-1);
  if( lastChar == "." || lastChar == "?" || lastChar == "!"){ sentenceArray.pop(); }
  const sentenceCount = sentenceArray.length;

  return sentenceCount;
}

function countAllChars(string) {
  const output = []
  let counter = 0
  const length = string.length

  while (counter < length) {
    const value = string.charCodeAt(counter++)

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {

      // It's a high surrogate, and there is a next character.
      const extra = string.charCodeAt(counter++)

      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000)
      } else {

        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.

        output.push(value)
        counter--
      }
    } else {
      output.push(value)
    }
  }

  return output
}

// parts of code inspred by Countable.js
const count = {
  paragraphs: (text, hardReturns = true) => {
    return text ? (text.match(hardReturns ? /\n{2,}/g : /\n+/g) || []).length + 1 : 0;
  },
  sentences: (text) => {
    return text ? countSentences(text) : 0;
  },
  words: (text) => {
    return text ? (text.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length : 0;
  },
  chars: (text) => {
    const chars = countAllChars(text.replace(/\s/g, '')).length;
    return chars ? chars : 0;
  },
  charsAll: (text) => {
    const charsAll = countAllChars(text).length;
    return charsAll ? charsAll : 0;
  },
  onlyLetters: (text) => {
    // includes all accented letters
    const onlyLetters = replaceString.onlyLettersAll(text).length;
    return onlyLetters ? onlyLetters : 0;
  },
  timeSpeaking: (words, locales) => {
    let wpmSpeaking = 150;
    if (locales === "en-US" && locales === "en-GB") wpmSpeaking = 150;
    // čeština mluvení: 80 až 100 slov za minutu
    if (locales === "cs-CZ") wpmSpeaking = 80;

    return secondsToHms(words / (wpmSpeaking / 60));
  },
  timeReading: (words, locales) => {
    let wpmReading = 200;
    if (locales === "en-US" && locales === "en-GB") wpmReading = 200;
    // čeština čtení: 150 až 200 slov za minutu
    if (locales === "cs-CZ") wpmReading = 150;

    return secondsToHms(words / (wpmReading / 60));
  },
  wordsPerSentence: (words = 0, sentences = 0) => {
    if(sentences <= 0) return 0;
    return words/sentences;
  },
  syllablesEnglish: () => {
    // todo: https://github.com/words/syllable
  },
  // total number of syllables, single syllable words etc
  syllablesCzech: (freshText) => {

    let totalSyllables = 0;
    let gunningHardWords = 0;
    let singleSyllablesCount = 0;

    let text = freshText;
    text = replaceString.onlyLettersCzech(text);

    // Replace multiple spaces with single
    text = replaceString.onlySingleSpace(text);

    const words = text.split(' ');
    
    // basic function - replace vowels with 1 and consonants with 0
    for( var i = 0; i < words.length; i++ ) {

      let word = words[i];
      if (word === "") continue;

      // české dvojhlásky - [ou] a v citoslovcích a přejatých slovech [au] a [eu]
      word = word.replace(/ou/gi,"1").replace(/au/gi,"1").replace(/eu/gi,"1"); // czech

      word = word.replace(/[bcdfghjklmnpqrstvwxyzčďňřšťž]/gi,"0"); // czech consonants
      word = word.replace(/[aeiouáéěíóůúý]/gi,"1"); // replace vowels with 1 // czech
      
      // count syllables
      var syllables = word.match(/1/g);

      if (syllables === null) continue;
      if (syllables.length === 0) continue;

      totalSyllables += syllables.length;
      if(syllables.length > 3) gunningHardWords++;
      if(syllables.length == 1) singleSyllablesCount++;
    }

    return {totalSyllables, singleSyllablesCount, gunningHardWords}
  }
}

export { count }